import React from 'react';

const TabToggle = ({ options = [], selected, onChange, className,disabled=false }) => {
    return (
        <div className="flex  w-max rounded-lg">
            {options.map((option,index) => {
                const isActive = selected === option.value;
                return (
                    <button
                    type='button'
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        disabled={disabled}
                        className={`w-20 ${className} ${index === 0 ? 'rounded-l-lg' : 'rounded-r-lg'}  py-1.5  text-sm font-medium transition-all
                            ${isActive ? 'bg-purple-600  text-white' : 'bg-gray-100 text-black'}`}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TabToggle;
